var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOtr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 0H10.125V1.125H5.625V0ZM7.875 18C3.52575 18 0 14.4742 0 10.125C0 5.77575 3.52575 2.25 7.875 2.25C12.2242 2.25 15.75 5.77575 15.75 10.125C15.75 14.4742 12.2242 18 7.875 18ZM14.625 10.125C14.625 6.39675 11.6032 3.375 7.875 3.375C4.14675 3.375 1.125 6.39675 1.125 10.125C1.125 13.8533 4.14675 16.875 7.875 16.875C11.6032 16.875 14.625 13.8533 14.625 10.125ZM14.2274 1.61995L13.4319 2.41544L15.0229 4.00642L15.8183 3.21093L14.2274 1.61995ZM7.875 10.125V4.49999C10.9811 4.49999 13.5 7.01887 13.5 10.125H7.875Z",
    fill: "#C4BBFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOtr);
export default __webpack_public_path__ + "static/media/OTR.5a319cd2.svg";
export { ForwardRef as ReactComponent };